module.exports = __webpack_public_path__ + "img/confirm-icon.1354e3e8.png";